import configHelper from '@/config/ConfigHelper'
import { i18n } from '@/i18n'

function GenerateConfig () {
  return [
    { id: 'AFG', key: 'AFG', name: i18n.t('tipos.pais.afg'), alfa2: 'AF' },
    { id: 'ALA', key: 'ALA', name: i18n.t('tipos.pais.ala'), alfa2: 'AX' },
    { id: 'ALB', key: 'ALB', name: i18n.t('tipos.pais.alb'), alfa2: 'AL' },
    { id: 'DEU', key: 'DEU', name: i18n.t('tipos.pais.deu'), alfa2: 'DE' },
    { id: 'AND', key: 'AND', name: i18n.t('tipos.pais.and'), alfa2: 'AD' },
    { id: 'AGO', key: 'AGO', name: i18n.t('tipos.pais.ago'), alfa2: 'AO' },
    { id: 'AIA', key: 'AIA', name: i18n.t('tipos.pais.aia'), alfa2: 'AI' },
    { id: 'ATA', key: 'ATA', name: i18n.t('tipos.pais.ata'), alfa2: 'AQ' },
    { id: 'ATG', key: 'ATG', name: i18n.t('tipos.pais.atg'), alfa2: 'AG' },
    { id: 'SAU', key: 'SAU', name: i18n.t('tipos.pais.sau'), alfa2: 'SA' },
    { id: 'DZA', key: 'DZA', name: i18n.t('tipos.pais.dza'), alfa2: 'DZ' },
    { id: 'ARG', key: 'ARG', name: i18n.t('tipos.pais.arg'), alfa2: 'AR' },
    { id: 'ARM', key: 'ARM', name: i18n.t('tipos.pais.arm'), alfa2: 'AM' },
    { id: 'ABW', key: 'ABW', name: i18n.t('tipos.pais.abw'), alfa2: 'AW' },
    { id: 'AUS', key: 'AUS', name: i18n.t('tipos.pais.aus'), alfa2: 'AU' },
    { id: 'AUT', key: 'AUT', name: i18n.t('tipos.pais.aut'), alfa2: 'AT' },
    { id: 'AZE', key: 'AZE', name: i18n.t('tipos.pais.aze'), alfa2: 'AZ' },
    { id: 'BHS', key: 'BHS', name: i18n.t('tipos.pais.bhs'), alfa2: 'BS' },
    { id: 'BGD', key: 'BGD', name: i18n.t('tipos.pais.bgd'), alfa2: 'BD' },
    { id: 'BRB', key: 'BRB', name: i18n.t('tipos.pais.brb'), alfa2: 'BB' },
    { id: 'BHR', key: 'BHR', name: i18n.t('tipos.pais.bhr'), alfa2: 'BH' },
    { id: 'BEL', key: 'BEL', name: i18n.t('tipos.pais.bel'), alfa2: 'BE' },
    { id: 'BLZ', key: 'BLZ', name: i18n.t('tipos.pais.blz'), alfa2: 'BZ' },
    { id: 'BEN', key: 'BEN', name: i18n.t('tipos.pais.ben'), alfa2: 'BJ' },
    { id: 'BMU', key: 'BMU', name: i18n.t('tipos.pais.bmu'), alfa2: 'BM' },
    { id: 'BLR', key: 'BLR', name: i18n.t('tipos.pais.blr'), alfa2: 'BY' },
    { id: 'BOL', key: 'BOL', name: i18n.t('tipos.pais.bol'), alfa2: 'BO' },
    { id: 'BES', key: 'BES', name: i18n.t('tipos.pais.bes'), alfa2: 'BQ' },
    { id: 'BIH', key: 'BIH', name: i18n.t('tipos.pais.bih'), alfa2: 'BA' },
    { id: 'BWA', key: 'BWA', name: i18n.t('tipos.pais.bwa'), alfa2: 'BW' },
    { id: 'BRA', key: 'BRA', name: i18n.t('tipos.pais.bra'), alfa2: 'BR' },
    { id: 'BRN', key: 'BRN', name: i18n.t('tipos.pais.brn'), alfa2: 'BN' },
    { id: 'BGR', key: 'BGR', name: i18n.t('tipos.pais.bgr'), alfa2: 'BG' },
    { id: 'BFA', key: 'BFA', name: i18n.t('tipos.pais.bfa'), alfa2: 'BF' },
    { id: 'BDI', key: 'BDI', name: i18n.t('tipos.pais.bdi'), alfa2: 'BI' },
    { id: 'BTN', key: 'BTN', name: i18n.t('tipos.pais.btn'), alfa2: 'BT' },
    { id: 'CPV', key: 'CPV', name: i18n.t('tipos.pais.cpv'), alfa2: 'CV' },
    { id: 'KHM', key: 'KHM', name: i18n.t('tipos.pais.khm'), alfa2: 'KH' },
    { id: 'CMR', key: 'CMR', name: i18n.t('tipos.pais.cmr'), alfa2: 'CM' },
    { id: 'CAN', key: 'CAN', name: i18n.t('tipos.pais.can'), alfa2: 'CA' },
    { id: 'QAT', key: 'QAT', name: i18n.t('tipos.pais.qat'), alfa2: 'QA' },
    { id: 'TCD', key: 'TCD', name: i18n.t('tipos.pais.tcd'), alfa2: 'TD' },
    { id: 'CHL', key: 'CHL', name: i18n.t('tipos.pais.chl'), alfa2: 'CL' },
    { id: 'CHN', key: 'CHN', name: i18n.t('tipos.pais.chn'), alfa2: 'CN' },
    { id: 'CYP', key: 'CYP', name: i18n.t('tipos.pais.cyp'), alfa2: 'CY' },
    { id: 'COL', key: 'COL', name: i18n.t('tipos.pais.col'), alfa2: 'CO' },
    { id: 'COM', key: 'COM', name: i18n.t('tipos.pais.com'), alfa2: 'KM' },
    { id: 'PRK', key: 'PRK', name: i18n.t('tipos.pais.prk'), alfa2: 'KP' },
    { id: 'KOR', key: 'KOR', name: i18n.t('tipos.pais.kor'), alfa2: 'KR' },
    { id: 'CIV', key: 'CIV', name: i18n.t('tipos.pais.civ'), alfa2: 'CI' },
    { id: 'CRI', key: 'CRI', name: i18n.t('tipos.pais.cri'), alfa2: 'CR' },
    { id: 'HRV', key: 'HRV', name: i18n.t('tipos.pais.hrv'), alfa2: 'HR' },
    { id: 'CUB', key: 'CUB', name: i18n.t('tipos.pais.cub'), alfa2: 'CU' },
    { id: 'CUW', key: 'CUW', name: i18n.t('tipos.pais.cuw'), alfa2: 'CW' },
    { id: 'DNK', key: 'DNK', name: i18n.t('tipos.pais.dnk'), alfa2: 'DK' },
    { id: 'DMA', key: 'DMA', name: i18n.t('tipos.pais.dma'), alfa2: 'DM' },
    { id: 'ECU', key: 'ECU', name: i18n.t('tipos.pais.ecu'), alfa2: 'EC' },
    { id: 'EGY', key: 'EGY', name: i18n.t('tipos.pais.egy'), alfa2: 'EG' },
    { id: 'SLV', key: 'SLV', name: i18n.t('tipos.pais.slv'), alfa2: 'SV' },
    { id: 'ARE', key: 'ARE', name: i18n.t('tipos.pais.are'), alfa2: 'AE' },
    { id: 'ERI', key: 'ERI', name: i18n.t('tipos.pais.eri'), alfa2: 'ER' },
    { id: 'SVK', key: 'SVK', name: i18n.t('tipos.pais.svk'), alfa2: 'SK' },
    { id: 'SVN', key: 'SVN', name: i18n.t('tipos.pais.svn'), alfa2: 'SI' },
    { id: 'ESP', key: 'ESP', name: i18n.t('tipos.pais.esp'), alfa2: 'ES' },
    { id: 'USA', key: 'USA', name: i18n.t('tipos.pais.usa'), alfa2: 'US' },
    { id: 'EST', key: 'EST', name: i18n.t('tipos.pais.est'), alfa2: 'EE' },
    { id: 'ETH', key: 'ETH', name: i18n.t('tipos.pais.eth'), alfa2: 'ET' },
    { id: 'PHL', key: 'PHL', name: i18n.t('tipos.pais.phl'), alfa2: 'PH' },
    { id: 'FIN', key: 'FIN', name: i18n.t('tipos.pais.fin'), alfa2: 'FI' },
    { id: 'FJI', key: 'FJI', name: i18n.t('tipos.pais.fji'), alfa2: 'FJ' },
    { id: 'FRA', key: 'FRA', name: i18n.t('tipos.pais.fra'), alfa2: 'FR' },
    { id: 'GAB', key: 'GAB', name: i18n.t('tipos.pais.gab'), alfa2: 'GA' },
    { id: 'GMB', key: 'GMB', name: i18n.t('tipos.pais.gmb'), alfa2: 'GM' },
    { id: 'GEO', key: 'GEO', name: i18n.t('tipos.pais.geo'), alfa2: 'GE' },
    { id: 'GHA', key: 'GHA', name: i18n.t('tipos.pais.gha'), alfa2: 'GH' },
    { id: 'GIB', key: 'GIB', name: i18n.t('tipos.pais.gib'), alfa2: 'GI' },
    { id: 'GRD', key: 'GRD', name: i18n.t('tipos.pais.grd'), alfa2: 'GD' },
    { id: 'GRC', key: 'GRC', name: i18n.t('tipos.pais.grc'), alfa2: 'GR' },
    { id: 'GRL', key: 'GRL', name: i18n.t('tipos.pais.grl'), alfa2: 'GL' },
    { id: 'GLP', key: 'GLP', name: i18n.t('tipos.pais.glp'), alfa2: 'GP' },
    { id: 'GUM', key: 'GUM', name: i18n.t('tipos.pais.gum'), alfa2: 'GU' },
    { id: 'GTM', key: 'GTM', name: i18n.t('tipos.pais.gtm'), alfa2: 'GT' },
    { id: 'GUF', key: 'GUF', name: i18n.t('tipos.pais.guf'), alfa2: 'GF' },
    { id: 'GGY', key: 'GGY', name: i18n.t('tipos.pais.ggy'), alfa2: 'GG' },
    { id: 'GIN', key: 'GIN', name: i18n.t('tipos.pais.gin'), alfa2: 'GN' },
    { id: 'GNB', key: 'GNB', name: i18n.t('tipos.pais.gnb'), alfa2: 'GW' },
    { id: 'GNQ', key: 'GNQ', name: i18n.t('tipos.pais.gnq'), alfa2: 'GQ' },
    { id: 'GUY', key: 'GUY', name: i18n.t('tipos.pais.guy'), alfa2: 'GY' },
    { id: 'HTI', key: 'HTI', name: i18n.t('tipos.pais.hti'), alfa2: 'HT' },
    { id: 'HND', key: 'HND', name: i18n.t('tipos.pais.hnd'), alfa2: 'HN' },
    { id: 'HKG', key: 'HKG', name: i18n.t('tipos.pais.hkg'), alfa2: 'HK' },
    { id: 'HUN', key: 'HUN', name: i18n.t('tipos.pais.hun'), alfa2: 'HU' },
    { id: 'IND', key: 'IND', name: i18n.t('tipos.pais.ind'), alfa2: 'IN' },
    { id: 'IDN', key: 'IDN', name: i18n.t('tipos.pais.idn'), alfa2: 'ID' },
    { id: 'IRQ', key: 'IRQ', name: i18n.t('tipos.pais.irq'), alfa2: 'IQ' },
    { id: 'IRN', key: 'IRN', name: i18n.t('tipos.pais.irn'), alfa2: 'IR' },
    { id: 'IRL', key: 'IRL', name: i18n.t('tipos.pais.irl'), alfa2: 'IE' },
    { id: 'BVT', key: 'BVT', name: i18n.t('tipos.pais.bvt'), alfa2: 'BV' },
    { id: 'IMN', key: 'IMN', name: i18n.t('tipos.pais.imn'), alfa2: 'IM' },
    { id: 'CXR', key: 'CXR', name: i18n.t('tipos.pais.cxr'), alfa2: 'CX' },
    { id: 'ISL', key: 'ISL', name: i18n.t('tipos.pais.isl'), alfa2: 'IS' },
    { id: 'CYM', key: 'CYM', name: i18n.t('tipos.pais.cym'), alfa2: 'KY' },
    { id: 'CCK', key: 'CCK', name: i18n.t('tipos.pais.cck'), alfa2: 'CC' },
    { id: 'COK', key: 'COK', name: i18n.t('tipos.pais.cok'), alfa2: 'CK' },
    { id: 'FRO', key: 'FRO', name: i18n.t('tipos.pais.fro'), alfa2: 'FO' },
    { id: 'SGS', key: 'SGS', name: i18n.t('tipos.pais.sgs'), alfa2: 'GS' },
    { id: 'HMD', key: 'HMD', name: i18n.t('tipos.pais.hmd'), alfa2: 'HM' },
    { id: 'FLK', key: 'FLK', name: i18n.t('tipos.pais.flk'), alfa2: 'FK' },
    { id: 'MNP', key: 'MNP', name: i18n.t('tipos.pais.mnp'), alfa2: 'MP' },
    { id: 'MHL', key: 'MHL', name: i18n.t('tipos.pais.mhl'), alfa2: 'MH' },
    { id: 'PCN', key: 'PCN', name: i18n.t('tipos.pais.pcn'), alfa2: 'PN' },
    { id: 'SLB', key: 'SLB', name: i18n.t('tipos.pais.slb'), alfa2: 'SB' },
    { id: 'TCA', key: 'TCA', name: i18n.t('tipos.pais.tca'), alfa2: 'TC' },
    { id: 'UMI', key: 'UMI', name: i18n.t('tipos.pais.umi'), alfa2: 'UM' },
    { id: 'VGB', key: 'VGB', name: i18n.t('tipos.pais.vgb'), alfa2: 'VG' },
    { id: 'VIR', key: 'VIR', name: i18n.t('tipos.pais.vir'), alfa2: 'VI' },
    { id: 'ISR', key: 'ISR', name: i18n.t('tipos.pais.isr'), alfa2: 'IL' },
    { id: 'ITA', key: 'ITA', name: i18n.t('tipos.pais.ita'), alfa2: 'IT' },
    { id: 'JAM', key: 'JAM', name: i18n.t('tipos.pais.jam'), alfa2: 'JM' },
    { id: 'JPN', key: 'JPN', name: i18n.t('tipos.pais.jpn'), alfa2: 'JP' },
    { id: 'JEY', key: 'JEY', name: i18n.t('tipos.pais.jey'), alfa2: 'JE' },
    { id: 'JOR', key: 'JOR', name: i18n.t('tipos.pais.jor'), alfa2: 'JO' },
    { id: 'KAZ', key: 'KAZ', name: i18n.t('tipos.pais.kaz'), alfa2: 'KZ' },
    { id: 'KEN', key: 'KEN', name: i18n.t('tipos.pais.ken'), alfa2: 'KE' },
    { id: 'KGZ', key: 'KGZ', name: i18n.t('tipos.pais.kgz'), alfa2: 'KG' },
    { id: 'KIR', key: 'KIR', name: i18n.t('tipos.pais.kir'), alfa2: 'KI' },
    { id: 'KWT', key: 'KWT', name: i18n.t('tipos.pais.kwt'), alfa2: 'KW' },
    { id: 'LAO', key: 'LAO', name: i18n.t('tipos.pais.lao'), alfa2: 'LA' },
    { id: 'LSO', key: 'LSO', name: i18n.t('tipos.pais.lso'), alfa2: 'LS' },
    { id: 'LVA', key: 'LVA', name: i18n.t('tipos.pais.lva'), alfa2: 'LV' },
    { id: 'LBN', key: 'LBN', name: i18n.t('tipos.pais.lbn'), alfa2: 'LB' },
    { id: 'LBR', key: 'LBR', name: i18n.t('tipos.pais.lbr'), alfa2: 'LR' },
    { id: 'LBY', key: 'LBY', name: i18n.t('tipos.pais.lby'), alfa2: 'LY' },
    { id: 'LIE', key: 'LIE', name: i18n.t('tipos.pais.lie'), alfa2: 'LI' },
    { id: 'LTU', key: 'LTU', name: i18n.t('tipos.pais.ltu'), alfa2: 'LT' },
    { id: 'LUX', key: 'LUX', name: i18n.t('tipos.pais.lux'), alfa2: 'LU' },
    { id: 'MAC', key: 'MAC', name: i18n.t('tipos.pais.mac'), alfa2: 'MO' },
    { id: 'MKD', key: 'MKD', name: i18n.t('tipos.pais.mkd'), alfa2: 'MK' },
    { id: 'MDG', key: 'MDG', name: i18n.t('tipos.pais.mdg'), alfa2: 'MG' },
    { id: 'MYS', key: 'MYS', name: i18n.t('tipos.pais.mys'), alfa2: 'MY' },
    { id: 'MWI', key: 'MWI', name: i18n.t('tipos.pais.mwi'), alfa2: 'MW' },
    { id: 'MDV', key: 'MDV', name: i18n.t('tipos.pais.mdv'), alfa2: 'MV' },
    { id: 'MLI', key: 'MLI', name: i18n.t('tipos.pais.mli'), alfa2: 'ML' },
    { id: 'MLT', key: 'MLT', name: i18n.t('tipos.pais.mlt'), alfa2: 'MT' },
    { id: 'MAR', key: 'MAR', name: i18n.t('tipos.pais.mar'), alfa2: 'MA' },
    { id: 'MTQ', key: 'MTQ', name: i18n.t('tipos.pais.mtq'), alfa2: 'MQ' },
    { id: 'MUS', key: 'MUS', name: i18n.t('tipos.pais.mus'), alfa2: 'MU' },
    { id: 'MRT', key: 'MRT', name: i18n.t('tipos.pais.mrt'), alfa2: 'MR' },
    { id: 'MYT', key: 'MYT', name: i18n.t('tipos.pais.myt'), alfa2: 'YT' },
    { id: 'MEX', key: 'MEX', name: i18n.t('tipos.pais.mex'), alfa2: 'MX' },
    { id: 'FSM', key: 'FSM', name: i18n.t('tipos.pais.fsm'), alfa2: 'FM' },
    { id: 'MDA', key: 'MDA', name: i18n.t('tipos.pais.mda'), alfa2: 'MD' },
    { id: 'MCO', key: 'MCO', name: i18n.t('tipos.pais.mco'), alfa2: 'MC' },
    { id: 'MNG', key: 'MNG', name: i18n.t('tipos.pais.mng'), alfa2: 'MN' },
    { id: 'MNE', key: 'MNE', name: i18n.t('tipos.pais.mne'), alfa2: 'ME' },
    { id: 'MSR', key: 'MSR', name: i18n.t('tipos.pais.msr'), alfa2: 'MS' },
    { id: 'MOZ', key: 'MOZ', name: i18n.t('tipos.pais.moz'), alfa2: 'MZ' },
    { id: 'MMR', key: 'MMR', name: i18n.t('tipos.pais.mmr'), alfa2: 'MM' },
    { id: 'NAM', key: 'NAM', name: i18n.t('tipos.pais.nam'), alfa2: 'NA' },
    { id: 'NRU', key: 'NRU', name: i18n.t('tipos.pais.nru'), alfa2: 'NR' },
    { id: 'NPL', key: 'NPL', name: i18n.t('tipos.pais.npl'), alfa2: 'NP' },
    { id: 'NIC', key: 'NIC', name: i18n.t('tipos.pais.nic'), alfa2: 'NI' },
    { id: 'NER', key: 'NER', name: i18n.t('tipos.pais.ner'), alfa2: 'NE' },
    { id: 'NGA', key: 'NGA', name: i18n.t('tipos.pais.nga'), alfa2: 'NG' },
    { id: 'NIU', key: 'NIU', name: i18n.t('tipos.pais.niu'), alfa2: 'NU' },
    { id: 'NFK', key: 'NFK', name: i18n.t('tipos.pais.nfk'), alfa2: 'NF' },
    { id: 'NOR', key: 'NOR', name: i18n.t('tipos.pais.nor'), alfa2: 'NO' },
    { id: 'NCL', key: 'NCL', name: i18n.t('tipos.pais.ncl'), alfa2: 'NC' },
    { id: 'NZL', key: 'NZL', name: i18n.t('tipos.pais.nzl'), alfa2: 'NZ' },
    { id: 'OMN', key: 'OMN', name: i18n.t('tipos.pais.omn'), alfa2: 'OM' },
    { id: 'NLD', key: 'NLD', name: i18n.t('tipos.pais.nld'), alfa2: 'NL' },
    { id: 'PAK', key: 'PAK', name: i18n.t('tipos.pais.pak'), alfa2: 'PK' },
    { id: 'PLW', key: 'PLW', name: i18n.t('tipos.pais.plw'), alfa2: 'PW' },
    { id: 'PSE', key: 'PSE', name: i18n.t('tipos.pais.pse'), alfa2: 'PS' },
    { id: 'PAN', key: 'PAN', name: i18n.t('tipos.pais.pan'), alfa2: 'PA' },
    { id: 'PNG', key: 'PNG', name: i18n.t('tipos.pais.png'), alfa2: 'PG' },
    { id: 'PRY', key: 'PRY', name: i18n.t('tipos.pais.pry'), alfa2: 'PY' },
    { id: 'PER', key: 'PER', name: i18n.t('tipos.pais.per'), alfa2: 'PE' },
    { id: 'PYF', key: 'PYF', name: i18n.t('tipos.pais.pyf'), alfa2: 'PF' },
    { id: 'POL', key: 'POL', name: i18n.t('tipos.pais.pol'), alfa2: 'PL' },
    { id: 'PRT', key: 'PRT', name: i18n.t('tipos.pais.prt'), alfa2: 'PT' },
    { id: 'PRI', key: 'PRI', name: i18n.t('tipos.pais.pri'), alfa2: 'PR' },
    { id: 'GBR', key: 'GBR', name: i18n.t('tipos.pais.gbr'), alfa2: 'GB' },
    { id: 'ESH', key: 'ESH', name: i18n.t('tipos.pais.esh'), alfa2: 'EH' },
    { id: 'CAF', key: 'CAF', name: i18n.t('tipos.pais.caf'), alfa2: 'CF' },
    { id: 'CZE', key: 'CZE', name: i18n.t('tipos.pais.cze'), alfa2: 'CZ' },
    { id: 'COG', key: 'COG', name: i18n.t('tipos.pais.cog'), alfa2: 'CG' },
    { id: 'COD', key: 'COD', name: i18n.t('tipos.pais.cod'), alfa2: 'CD' },
    { id: 'DOM', key: 'DOM', name: i18n.t('tipos.pais.dom'), alfa2: 'DO' },
    { id: 'REU', key: 'REU', name: i18n.t('tipos.pais.reu'), alfa2: 'RE' },
    { id: 'RWA', key: 'RWA', name: i18n.t('tipos.pais.rwa'), alfa2: 'RW' },
    { id: 'ROU', key: 'ROU', name: i18n.t('tipos.pais.rou'), alfa2: 'RO' },
    { id: 'RUS', key: 'RUS', name: i18n.t('tipos.pais.rus'), alfa2: 'RU' },
    { id: 'WSM', key: 'WSM', name: i18n.t('tipos.pais.wsm'), alfa2: 'WS' },
    { id: 'ASM', key: 'ASM', name: i18n.t('tipos.pais.asm'), alfa2: 'AS' },
    { id: 'BLM', key: 'BLM', name: i18n.t('tipos.pais.blm'), alfa2: 'BL' },
    { id: 'KNA', key: 'KNA', name: i18n.t('tipos.pais.kna'), alfa2: 'KN' },
    { id: 'SMR', key: 'SMR', name: i18n.t('tipos.pais.smr'), alfa2: 'SM' },
    { id: 'MAF', key: 'MAF', name: i18n.t('tipos.pais.maf'), alfa2: 'MF' },
    { id: 'SPM', key: 'SPM', name: i18n.t('tipos.pais.spm'), alfa2: 'PM' },
    { id: 'VCT', key: 'VCT', name: i18n.t('tipos.pais.vct'), alfa2: 'VC' },
    { id: 'SHN', key: 'SHN', name: i18n.t('tipos.pais.shn'), alfa2: 'SH' },
    { id: 'LCA', key: 'LCA', name: i18n.t('tipos.pais.lca'), alfa2: 'LC' },
    { id: 'STP', key: 'STP', name: i18n.t('tipos.pais.stp'), alfa2: 'ST' },
    { id: 'SEN', key: 'SEN', name: i18n.t('tipos.pais.sen'), alfa2: 'SN' },
    { id: 'SRB', key: 'SRB', name: i18n.t('tipos.pais.srb'), alfa2: 'RS' },
    { id: 'SYC', key: 'SYC', name: i18n.t('tipos.pais.syc'), alfa2: 'SC' },
    { id: 'SLE', key: 'SLE', name: i18n.t('tipos.pais.sle'), alfa2: 'SL' },
    { id: 'SGP', key: 'SGP', name: i18n.t('tipos.pais.sgp'), alfa2: 'SG' },
    { id: 'SXM', key: 'SXM', name: i18n.t('tipos.pais.sxm'), alfa2: 'SX' },
    { id: 'SYR', key: 'SYR', name: i18n.t('tipos.pais.syr'), alfa2: 'SY' },
    { id: 'SOM', key: 'SOM', name: i18n.t('tipos.pais.som'), alfa2: 'SO' },
    { id: 'LKA', key: 'LKA', name: i18n.t('tipos.pais.lka'), alfa2: 'LK' },
    { id: 'SWZ', key: 'SWZ', name: i18n.t('tipos.pais.swz'), alfa2: 'SZ' },
    { id: 'ZAF', key: 'ZAF', name: i18n.t('tipos.pais.zaf'), alfa2: 'ZA' },
    { id: 'SDN', key: 'SDN', name: i18n.t('tipos.pais.sdn'), alfa2: 'SD' },
    { id: 'SSD', key: 'SSD', name: i18n.t('tipos.pais.ssd'), alfa2: 'SS' },
    { id: 'SWE', key: 'SWE', name: i18n.t('tipos.pais.swe'), alfa2: 'SE' },
    { id: 'CHE', key: 'CHE', name: i18n.t('tipos.pais.che'), alfa2: 'CH' },
    { id: 'SUR', key: 'SUR', name: i18n.t('tipos.pais.sur'), alfa2: 'SR' },
    { id: 'SJM', key: 'SJM', name: i18n.t('tipos.pais.sjm'), alfa2: 'SJ' },
    { id: 'THA', key: 'THA', name: i18n.t('tipos.pais.tha'), alfa2: 'TH' },
    { id: 'TWN', key: 'TWN', name: i18n.t('tipos.pais.twn'), alfa2: 'TW' },
    { id: 'TZA', key: 'TZA', name: i18n.t('tipos.pais.tza'), alfa2: 'TZ' },
    { id: 'TJK', key: 'TJK', name: i18n.t('tipos.pais.tjk'), alfa2: 'TJ' },
    { id: 'IOT', key: 'IOT', name: i18n.t('tipos.pais.iot'), alfa2: 'IO' },
    { id: 'ATF', key: 'ATF', name: i18n.t('tipos.pais.atf'), alfa2: 'TF' },
    { id: 'TLS', key: 'TLS', name: i18n.t('tipos.pais.tls'), alfa2: 'TL' },
    { id: 'TGO', key: 'TGO', name: i18n.t('tipos.pais.tgo'), alfa2: 'TG' },
    { id: 'TKL', key: 'TKL', name: i18n.t('tipos.pais.tkl'), alfa2: 'TK' },
    { id: 'TON', key: 'TON', name: i18n.t('tipos.pais.ton'), alfa2: 'TO' },
    { id: 'TTO', key: 'TTO', name: i18n.t('tipos.pais.tto'), alfa2: 'TT' },
    { id: 'TUN', key: 'TUN', name: i18n.t('tipos.pais.tun'), alfa2: 'TN' },
    { id: 'TKM', key: 'TKM', name: i18n.t('tipos.pais.tkm'), alfa2: 'TM' },
    { id: 'TUR', key: 'TUR', name: i18n.t('tipos.pais.tur'), alfa2: 'TR' },
    { id: 'TUV', key: 'TUV', name: i18n.t('tipos.pais.tuv'), alfa2: 'TV' },
    { id: 'UKR', key: 'UKR', name: i18n.t('tipos.pais.ukr'), alfa2: 'UA' },
    { id: 'UGA', key: 'UGA', name: i18n.t('tipos.pais.uga'), alfa2: 'UG' },
    { id: 'URY', key: 'URY', name: i18n.t('tipos.pais.ury'), alfa2: 'UY' },
    { id: 'UZB', key: 'UZB', name: i18n.t('tipos.pais.uzb'), alfa2: 'UZ' },
    { id: 'VUT', key: 'VUT', name: i18n.t('tipos.pais.vut'), alfa2: 'VU' },
    { id: 'VAT', key: 'VAT', name: i18n.t('tipos.pais.vat'), alfa2: 'VA' },
    { id: 'VEN', key: 'VEN', name: i18n.t('tipos.pais.ven'), alfa2: 'VE' },
    { id: 'VNM', key: 'VNM', name: i18n.t('tipos.pais.vnm'), alfa2: 'VN' },
    { id: 'WLF', key: 'WLF', name: i18n.t('tipos.pais.wlf'), alfa2: 'WF' },
    { id: 'YEM', key: 'YEM', name: i18n.t('tipos.pais.yem'), alfa2: 'YE' },
    { id: 'DJI', key: 'DJI', name: i18n.t('tipos.pais.dji'), alfa2: 'DJ' },
    { id: 'ZMB', key: 'ZMB', name: i18n.t('tipos.pais.zmb'), alfa2: 'ZM' },
    { id: 'ZQU', key: 'ZQU', name: i18n.t('tipos.pais.zqu'), alfa2: 'QU' },
    { id: 'ZWE', key: 'ZWE', name: i18n.t('tipos.pais.zwe'), alfa2: 'ZW' },
    { id: 'ZXB', key: 'ZXB', name: i18n.t('tipos.pais.zxb'), alfa2: 'XB' },
    { id: 'ZXG', key: 'ZXG', name: i18n.t('tipos.pais.zxg'), alfa2: 'XG' },
    // { id: 'ZXG', key: 'ZXG', name: 'Luxemburgo (por lo que respecta a las rentas percibidas por las Sociedades a que se refiere el párrafo 1 del protocolo anexo al Convenio de doble imposición [3 junio 1986])', alfa2: 'XG' },
    { id: 'ZXN', key: 'ZXN', name: i18n.t('tipos.pais.zxn'), alfa2: 'XN' },
    // { id: 'ZXN', key: 'ZXN', name: 'Organismos internacionales distintos de las instituciones de la Unión Europea y del Banco Central Europeo', alfa2: 'XN' },
    { id: 'ZXU', key: 'ZXU', name: i18n.t('tipos.pais.zxu'), alfa2: 'XU' },
  ]
}

export function PAISES (state) {
  return configHelper.getConfig(state, 'PAISES', GenerateConfig)
}
